export const paginate = (rowsPerPage: number, page: number, rows: any[]) => {
  return rows.length > rowsPerPage
    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : rows;
};

export const pageCounter = (rowsPerPage: number, rows: any[]) => {
  return Math.ceil(rows.length / rowsPerPage);
};
